import React, { useRef, useState } from 'react'

import PropTypes from 'prop-types'

import LinearIconHelper from '../../../atoms/LinearIconHelper/LinearIconHelper'
import { ContextHeadline } from '@aok/text-elements'
import { Accordion, AccordionElement, Link, SecondaryButton } from '@aok/ui-elements'
import { ArrowDown, ArrowRoundedRight } from '@aok/icon-functional'
import { collapsable } from '@aok/accordion'

import defaultProps from '../../../../utils/propTypes/defaultProps'

const M047Summary = ({ headline, text, points, summaryText, startAgain, showSummaryText }) => {
  const collapsableRef = useRef(null)
  const collapsableRefTarget = useRef(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const currentSummary = summaryText.find(
    (summaryElement) => summaryElement.from <= points && summaryElement.to >= points
  )

  return (
    <div className="px-16 720:px-48 1000:px-64">
      <div className="flex justify-center">
        <div className="rounded-full bg-ffffff p-16">
          <LinearIconHelper name="bonus" className="text-005e3f fill-current" />
        </div>
      </div>
      <ContextHeadline
        text={headline.text}
        className="
          text-24 leading-32 text-005e3f
          font-semibold font-buenos-aires mt-16 text-center 1280:leading-36"
      />
      <p className="mt-16 text-center">{text}</p>
      <div className="flex justify-center mt-24">
        <div className="rounded-full px-32 py-16 bg-d8ece8 text-005e3f text-20 font-semibold leading-28 font-buenos-aires">
          {points} Punkte
        </div>
      </div>
      <div className="font-semibold font-buenos-aires mt-40 600:mt-48">
        <ContextHeadline {...currentSummary.headline} />
      </div>
      <div className="textBlock mt-8" dangerouslySetInnerHTML={{ __html: currentSummary?.text }}></div>
      {currentSummary?.linkList && (
        <div className="flex flex-col gap-y-16 mt-16 ">
          {currentSummary.linkList.map((link, index) => {
            return (
              <Link
                key={index}
                className="text-left"
                title={link?.title}
                href={link?.url}
                variant="structure"
                icon={<ArrowRoundedRight className="shrink-0 fill-current mb-2" />}
              ></Link>
            )
          })}
        </div>
      )}

      {showSummaryText && (
        <div className="mt-40 600:mt-48">
          <Link
            ref={collapsableRef}
            type="button"
            title="Alle Auswertungen"
            onClick={() => {
              const newOpenState = collapsable(collapsableRef.current, collapsableRefTarget.current)
              setIsDropdownOpen(newOpenState)
            }}
            className={`${isDropdownOpen && 'mb-16'}`}
            theme="secondary"
            variant="structure"
            icon={<ArrowDown className={`fill-current w-16 h-16 ${isDropdownOpen ? 'rotate-180' : ''}`} />}
          />

          <div
            className="
              h-0 overflow-hidden
              transition-all duration-500 ease-in-out
            "
            ref={collapsableRefTarget}
          >
            <Accordion>
              {summaryText.map((summary, index) => {
                return (
                  <AccordionElement
                    settings={{ bgVariant: 'structure' }}
                    key={`m047-summary-${index}`}
                    headline={summary?.headline}
                  >
                    <div className="textBlock" dangerouslySetInnerHTML={{ __html: summary.text }}></div>
                    {summary.linkList && (
                      <div className="flex flex-col gap-y-16 mt-12">
                        {summary.linkList.map((link, index) => {
                          return (
                            <Link
                              key={index}
                              className="text-left"
                              title={link?.title}
                              href={link?.url}
                              variant="structure"
                              icon={<ArrowRoundedRight className="shrink-0 fill-current ml-0 mb-2" />}
                            ></Link>
                          )
                        })}
                      </div>
                    )}
                  </AccordionElement>
                )
              })}
            </Accordion>
          </div>
        </div>
      )}
      <SecondaryButton className="mx-auto mt-40 600:mt-48" onClick={startAgain}>
        Quiz erneut starten
      </SecondaryButton>
    </div>
  )
}

M047Summary.propTypes = {
  headline: PropTypes.shape({
    tag: PropTypes.string,
    text: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
  text: PropTypes.string,
  points: PropTypes.number,
  summaryText: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.shape({
        tag: PropTypes.string,
        text: PropTypes.string,
        placeholder: PropTypes.shape({
          text: PropTypes.string,
        }),
      }),
      text: PropTypes.string,
      from: PropTypes.number,
      to: PropTypes.number,
      linkList: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
        })
      ),
    })
  ),
  startAgain: PropTypes.func,
  showSummaryText: PropTypes.bool,
}

M047Summary.defaultProps = {
  headline: {
    tag: 'h4',
    text: defaultProps.HEADLINE,
  },
  summaryText: [
    {
      headline: { tag: 'h4', text: defaultProps.HEADLINE },
      text: defaultProps.TEXT,
      from: 0,
      to: 1,
    },
  ],
}

export default M047Summary
